import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6 0a1 1 0 0 1 .894.553L8.16 3.084l2.981.426a1 1 0 0 1 .566 1.697L9.561 7.354l.429 3.005a1 1 0 0 1-1.545.973L6 9.702l-2.445 1.63a1 1 0 0 1-1.545-.973l.43-3.005L.292 5.207A1 1 0 0 1 .859 3.51l2.98-.426L5.107.553A1 1 0 0 1 6 0Zm0 3.236-.606 1.211a1 1 0 0 1-.753.543l-1.52.217 1.086 1.086a1 1 0 0 1 .283.848l-.184 1.286 1.14-.759a1 1 0 0 1 1.109 0l1.139.76L7.51 7.14a1 1 0 0 1 .283-.848l1.086-1.086-1.52-.217a1 1 0 0 1-.753-.543L6 3.237Z",
      fill: "currentColor"
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconToggleStarOff12 = createIcon(IconComponent);